import React, { useState, useContext } from 'react';
import tw from 'twin.macro';
import { Icon } from '../icon';
import { Kudos } from '../kudos';
import { ReportForm } from '../form';
import { SocialSharing } from '../social';
import { FlagIcon, TimesIcon } from 'icons';
import { PlaylistsContextProvider, AppContext, UserContext } from '../context';
import { kudoItem } from 'services/dumpert';
import { TextLine, TitleRow } from '../text';
import { gaEvent } from 'services/ga';
import { PlaylistAddItem } from '../features/playlist';

export const ItemActionsBar = ({ item, isMobile }) => {
  const { user } = useContext(UserContext);
  const { slideIn } = useContext(AppContext);
  const [reportFormActive, setReportFormActive] = useState(false);

  const { mediatype, variants } = item.media[0];
  const [{ version }] = variants;

  return (
    <>
      <div
        css={[
          tw`bg-primary bg-opacity-70 backdrop-blur-lg contrast-75 sticky z-30 lg:px-0`,
          !slideIn.active && tw`top-14`,
          slideIn.active && tw`top-[-1px]`,
        ]}
      >
        <div tw='flex h-14 justify-between items-center px-4'>
          <div tw='flex gap-3 md:gap-4'>
            <SocialSharing item={item} title={item.title} path={`/item/${item.id}`} />
            {mediatype === 'VIDEO' && version !== 'embed' && user && (
              <PlaylistsContextProvider>
                <PlaylistAddItem itemId={item.id} isMobile={isMobile} />
              </PlaylistsContextProvider>
            )}
            <div tw='flex items-center transition-all hover:opacity-75 hover:scale-110 active:scale-95'>
              <Icon
                Type={FlagIcon}
                tw='cursor-pointer'
                onClick={() => {
                  gaEvent('dmp_detail_page', 'report_button');
                  setReportFormActive(!reportFormActive);
                }}
                color={reportFormActive ? 'danger' : 'icons'}
              />
            </div>
          </div>
          <div tw='flex'>
            <Kudos
              numOfKudos={(item.stats || {}).kudos_total}
              large
              clickUp={() => {
                gaEvent('dmp_detail_page', 'kudo_up');
                return kudoItem(item.id, 'up');
              }}
              clickDown={() => {
                gaEvent('dmp_detail_page', 'kudo_down');
                return kudoItem(item.id, 'down');
              }}
            />
          </div>
        </div>
        {reportFormActive && (
          <div tw='bg-secondary contrast-125 px-4 pb-4 rounded-md mt-2'>
            <div className='group text-light'>
              <TitleRow
                Type='h5'
                text='Item melden'
                RightBlock={() => (
                  <Icon
                    Type={TimesIcon}
                    tw='cursor-pointer'
                    onClick={() => setReportFormActive(false)}
                  />
                )}
              />
              <TextLine text='Selecteer hieronder wat je wilt melden:' tw='block mb-2' />
              <ReportForm itemId={item.id} setReportFormActive={setReportFormActive} />
            </div>
          </div>
        )}
      </div>
    </>
  );
};
